import {Component, effect, model, signal, viewChildren} from '@angular/core'
import {FormsModule, NgModel} from '@angular/forms'
import {
  MatDatepickerToggle,
  MatDateRangeInput,
  MatDateRangePicker,
  MatEndDate,
  MatStartDate
} from '@angular/material/datepicker'
import {MatFormField, MatHint, MatLabel, MatSuffix} from '@angular/material/input'
import {BaseComponent} from '../base.component'
import {provideDates} from '../../../application/app'
import {DateTime} from 'luxon'

@Component({
  selector: 'spb-date-range-select',
  imports: [
    FormsModule,
    MatDateRangeInput,
    MatDateRangePicker,
    MatDatepickerToggle,
    MatEndDate,
    MatFormField,
    MatHint,
    MatLabel,
    MatStartDate,
    MatSuffix
  ],
  templateUrl: './date-range-select.component.html',
  providers: [
    provideDates(),
    {provide: BaseComponent, useExisting: DateRangeSelectComponent}]
})
export class DateRangeSelectComponent {

  public start = model.required<DateTime | null>()
  public end = model.required<DateTime | null>()

  public children = viewChildren<NgModel>('tr')

  public valid = signal(false)

  constructor() {
    effect(() => {
      this.valid.set(
        this.end() !== null && this.start() !== null &&
        this.children().every(child => child.valid))
    })
  }
}
